import "./ModalComp.css";
import { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Fade } from "@mui/material";

export default function ModalComp({ itemData, setOpen, open }) {
  const [index, setIndex] = useState(0);

  const handleClose = () => {
    setOpen(false);
    setIndex(0);
  };

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex + 1) % itemData.length);
  };

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex - 1 + itemData.length) % itemData.length);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Fade in={open} timeout={300}>
        <Box sx={{
          position: 'relative',
          width: '90%',
          maxWidth: '1200px',
          maxHeight: '90vh',
          bgcolor: 'rgba(33, 32, 32, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          p: 4,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: '#72efdd',
              zIndex: 1,
              '&:hover': {
                backgroundColor: 'rgba(114, 239, 221, 0.1)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box sx={{
            position: 'relative',
            width: '100%',
            height: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: 1,
            bgcolor: 'rgba(0, 0, 0, 0.2)',
            mt: 4
          }}>
            <img
              src={itemData[index].img}
              alt={itemData[index].title}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: '4px'
              }}
            />
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            px: 2
          }}>
            <IconButton
              onClick={handlePrev}
              sx={{
                color: '#72efdd',
                '&:hover': {
                  backgroundColor: 'rgba(114, 239, 221, 0.1)',
                }
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            <Box sx={{
              textAlign: 'center',
              color: 'white',
              fontSize: '1.1rem',
              fontWeight: 500,
              flex: 1,
              mx: 4
            }}>
              {itemData[index].title}
            </Box>

            <IconButton
              onClick={handleNext}
              sx={{
                color: '#72efdd',
                '&:hover': {
                  backgroundColor: 'rgba(114, 239, 221, 0.1)',
                }
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
